export function mergeAPIError(error: any) {
    if (Array.isArray(error?.errors) && error?.errors.length > 0) {
        const txt = error.errors.map((i: any) => i?.message).join('\n');

        return error?.detail ? `${error?.detail}: - ${txt}` : txt;
    }
    return (
        error?.errors?.[0]?.message ||
        error?.detail ||
        error?.title ||
        error?.error ||
        error?.message
    );
}

export function ErrorMessage(error: string) {
    switch (error) {
        case 'input_error':
            return 'Input Error';

        case 'payment_rejected':
            return 'User cancelled payment';

        case 'invalid_receiver':
            return 'Invalid Receiver';

        case 'insufficient_balance':
            return 'Insufficient Balance';

        case 'transaction_failed':
            return 'Transaction Failed';

        case 'generic_error':
            return 'Transaction Failed';

        case 'user_blocked':
            return 'User Blocked';

        case 'daily_tx_limit_reached':
            return 'World app only allow 25 transactions/day';

        case 'user_rejected':
            return 'User Rejected';
        // verification error
        case 'verification_rejected':
            return 'User rejected';

        case 'max_verifications_reached':
            return 'User cannot verify for this action again';

        case 'credential_unavailable':
            return 'This user does not have the requested credential';

        case 'malformed_request':
            return "The request payload couldn't be decrypted or did not conform to the standard";

        case 'invalid_network':
            return "The application is configured for a different environment than the verifying user's client";

        case 'inclusion_proof_failed':
            return 'The sequencer returned an unexpected error when retrieving the inclusion proof. Please try again';

        case 'inclusion_proof_pending':
            return 'Ask the user to verify again in approximately one hour';

        case 'unexpected_response':
            return 'There was a problem with the response obtained from the WLD app';

        case 'invalid_contract':
            return 'Invalid Contract';

        case 'simulation_failed':
            return 'Simulation provider transaction simulation failed.';

        case 'invalid_operation':
            return 'Transaction included an operation that was invalid';

        case 'network_congestion': {
            return 'network_congestion';
        }

        default:
            return error;
    }
}
